module.exports = __webpack_public_path__ + "media/images/timeBreakdownReport-3ee3e0d8f8cc15a33f57554670e2282e2ce537c71b5e968722ff75ed4e9e6bc2.svg";